import { NotificationConfiguration } from 'src/models/userInterfaceSettings';

import { Callback } from 'src/util/query/models/Callback';

export class GetTheNotificationConfigurationQueryCallBack extends Callback<NotificationConfiguration[]> {
	public constructor(
		private readonly applyNotificationConfiguration: (
			notificationConfiguration: NotificationConfiguration | undefined
		) => void
	) {
		super();
	}

	failureCallbackFunction = (failureResponse: unknown): void => {
		this.logFailureResponse(failureResponse);
	};

	successCallbackFunction = (successResponse: NotificationConfiguration[]): void => {
		this.applyNotificationConfiguration(successResponse.pop());
	};
}
